import { NgModule } from '@angular/core';
import { RouterModule, Route } from '@angular/router';
import { AuthGuard } from '@core/guards/auth.guard';
import { AppInitializationWithUriPage } from '@pages/auth/app-initialization-with-uri.page';

import { AppInitializationPage } from '@pages/auth/app-initialization.page';
import { LoginPage } from '@pages/auth/login.page';

const routes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    path: 'login',
    title: 'Entire OnHire - Client Portal',
    component: LoginPage
  },
  {
    path: 'app-initialization',
    title: 'Entire OnHire - Client Portal',
    component: AppInitializationPage
  },
  {
    path: 'uri',
    title: 'Entire OnHire - Client Portal',
    component: AppInitializationWithUriPage
  },
  {
    path: 'client',
    canLoad: [AuthGuard],
    loadChildren: () => import('@core/core.module').then(module => module.CoreModule)
  },
  {
    path: 'professional',
    canLoad: [AuthGuard],
    loadChildren: () => import('@core/core.module').then(module => module.CoreModule)
  },
  {
    path: 'error',
    loadChildren: () => import('@modules/error/error.module').then(module => module.ErrorModule)
  },
  {
    path: '**',
    redirectTo: 'error/404'
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }